import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import { BootstrapVueIcons } from 'bootstrap-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import 'swiper/css/swiper.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Banner from '@/components/banner.vue'
import Layoutimg from '@/components/layoutimg.vue'
import Layoutimgp from '@/components/layoutimgp.vue'
import LittleBar from '@/components/littleBar.vue'
import { BIcon } from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import tool from './common/utils'
import api from './api/api'
import forumApi from './api/forumApi'
import { setCookie, getCookie, delCookie } from './common/utils/cookie';
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
Vue.use(VueVideoPlayer)
Vue.use(VueI18n) // 通过插件的形式挂载
Vue.use(BootstrapVueIcons)
Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper)
Vue.component('b-icon', BIcon)
Vue.component('banner', Banner)
Vue.component('layoutimg', Layoutimg)
Vue.component('layoutimgp', Layoutimgp)
Vue.component('little-bar', LittleBar)
Vue.config.productionTip = false
Vue.prototype.$tools = tool
Vue.prototype.$api = api; //  未来科学API
Vue.prototype.$forumApi = forumApi;
Vue.prototype.$cookie = {
    setCookie,
    getCookie,
    delCookie
}
console.dir(Vue.$store)
const i18n = new VueI18n({
    locale: 'cn', // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'cn': require('./common/lang/zh'), // 中文语言包
        'en': require('./common/lang/en') // 英文语言包
    }
})

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0)

    if (to.meta.title) {
        document.title = to.meta.title
    }

    if (store.state.browserTitle) {
        console.log(store.state.browserTitle)
        document.title = store.state.browserTitle
    }
    next()
})

new Vue({
    store,
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')